import mitt from 'mitt';


export const emitter = mitt<{
  'updated:notSelectedFiles': void,
  'add:successFiles': void,
  'projectsUpdated': Set<number>,
}>();
